<template>
  <div style="display: flex; justify-content: space-between; gap: .5rem;">
    <NxMoney labelText="De:"
    id="valorInicial" :value="localInitialValue" @update:value="handleInitialValueUpdate"></NxMoney>
    <NxMoney labelText="Até:"
    id="valorFinal" :value="localFinalValue" @update:value="handleFinalValueUpdate"></NxMoney>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
import NxMoney from '@/components/nexum/components/inputs/NxMoney.vue'

export default {
  name: 'NxInputMoneyRange',
  mixins: [useReactiveModelMixin('InitialValue'), useReactiveModelMixin('FinalValue')],
  components: {NxMoney},
  methods: {
    handleInitialValueUpdate (val) {
      this.localInitialValue = val
    },
    handleFinalValueUpdate (val) {
      this.localFinalValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputMoneyRange.vue